import type { TourConfig } from "~/features/onboarding/types/tour-config";

// AIDEV-NOTE: Onboarding-checklist coach-mark. The "Chat with the consultant"
// item deep-links to the practitioner's most recent consultation
// (/reflections/:sessionId) and starts this tour, highlighting the session
// consultation chat input (data-tour-id="session-consultant-chat-input").
// Copy + starter queries grounded in real usage (chat-analysis/ R&D) and the
// single-session feature copy — see docs/specs/practitioner-onboarding-checklist.md.
export const consultantChatCalloutTourConfig: TourConfig = {
    id: "consultant-chat-callout",
    page: "/reflections",

    welcome: {
        title: "Chat about this session",
        description: "Talk this session through with your AI consultant.",
        startButtonText: "Show me",
        skipButtonText: "Skip",
    },

    steps: [
        {
            id: "session-consultant-chat-input",
            targetSelector: "[data-tour-id='session-consultant-chat-input']",
            title: "Chat about this session",
            content:
                "Talk it through with an AI consultant who's already reviewed this session's transcript. Ask about specific moments, explore teachable points, or process your own parts activation. Try:",
            exampleQueries: [
                "What themes emerged in this session?",
                "How should I start our next session, and what are good next steps?",
                "What parts of mine got activated here?",
            ],
            position: "top",
            disableBackdropClose: true,
        },
    ],
};
